import React from 'react'
import { Link } from 'react-router-dom'

const BlogDetails = () => {
    return (
        <section className="blog-details py-80">
            <div className="container container-lg">
                <div className="row gy-5">
                    <div className="col-lg-8 pe-xl-4">
                        <div className="blog-item-wrapper">
                            <div className="blog-item">
                                <img
                                    src="assets/images/thumbs/blog-img1.png"
                                    alt=""
                                    className="cover-img rounded-16"
                                />
                                <div className="blog-item__content mt-24">
                                    <span className="bg-main-50 text-main-600 py-4 px-24 rounded-8 mb-16 blog-category-badge">
                                        Recettes & Conseils
                                    </span>
                                    <h4 className="mb-24">
                                        Comment Déguster le Khalie : 4 Façons Savoureuses
                                    </h4>
                                    <p className="text-gray-700 mb-24 blog-intro-text">
                                        Le Khalie est un trésor de la cuisine marocaine, apprécié pour son goût intense et sa polyvalence. Voici quatre façons délicieuses de le déguster
                                    </p>
                                    <h6 className="mb-16">1. Khalie aux Œufs</h6>
                                    <p className="text-gray-700 mb-24">
                                        Faites chauffer le Khalie dans une poêle, ajoutez des œufs battus et mélangez jusqu'à obtention d'une texture crémeuse. Un plat simple et savoureux, parfait pour le petit déjeuner ou un dîner léger.
                                    </p>
                                    <h6 className="mb-16">2. Khalie avec Lentilles</h6>
                                    <p className="text-gray-700 mb-24">
                                        Faites cuire des lentilles avec les épices, puis ajoutez le Khalie pour infuser toute sa richesse dans le plat. Un mariage parfait entre protéines végétales et viande, idéal pour un repas complet.
                                    </p>
                                    <h6 className="mb-16">3. Khalie avec Couscous</h6>
                                    <p className="text-gray-700 mb-24">
                                        Intégrez le Khalie dans la préparation de votre couscous traditionnel en l'ajoutant aux légumes et aux épices. Laissez mijoter le tout pour que le Khalie infuse ses saveurs dans chaque grain de couscous. Ce plat est parfait pour les grandes occasions ou les repas familiaux, offrant un goût authentique et un mélange parfait entre viande et légumes.
                                    </p>
                                    <h6 className="mb-16">4. Khalie avec Rghaïfs</h6>
                                    <p className="text-gray-700 pb-24 mb-24 border-bottom border-gray-100">
                                        Intégrez le Khalie directement dans la pâte des rghaïfs avant de les cuire. En roulant la pâte avec des morceaux de Khalie, vous obtiendrez des galettes savoureuses et fondantes à l'intérieur, avec une légère croûte dorée à l'extérieur. Ce mariage parfait entre la pâte feuilletée et le Khalie transformera vos rghaïfs en un plat encore plus gourmand et traditionnel, idéal pour un repas convivial ou en snack.
                                    </p>
                                    <div className="flex-align flex-wrap gap-24">
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-calendar">
                                                <i className="ph ph-calendar-dots" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-date-link"
                                                >
                                                    20 Décembre 2024
                                                </Link>
                                            </span>
                                        </div>
                                        <div className="flex-align flex-wrap gap-8">
                                            <span className="text-lg blog-icon-comment">
                                                <i className="ph ph-chats-circle" />
                                            </span>
                                            <span className="text-sm text-gray-500">
                                                <Link
                                                    to="/blog-details"
                                                    className="text-gray-500 blog-comment-link"
                                                >
                                                    12 Commentaires
                                                </Link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-48">
                            <div className="row gy-4">
                                <div className="col-sm-6 col-xs-6">
                                    <img
                                        src="assets/images/thumbs/blog-details-img1.png"
                                        alt=""
                                        className="rounded-16"
                                    />
                                </div>
                                <div className="col-sm-6 col-xs-6">
                                    <img
                                        src="assets/images/thumbs/blog-details-img2.png"
                                        alt=""
                                        className="rounded-16"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mt-48">
                            <p className="text-gray-700 mb-24">
                                Le Khalie est un produit riche en saveurs, polyvalent et facile à intégrer dans différents plats. Il peut être dégusté de nombreuses façons, offrant une touche authentique et traditionnelle à vos repas.
                            </p>
                            <p className="text-gray-700 mb-24">
                                Chez Délices Benkirane, nous vous proposons le Khalie avec tout le soin et l'authenticité qui caractérisent nos produits. Alors, laissez-vous tenter par nos délices et réinventez vos repas avec le Khalie !
                            </p>
                        </div>
                        <div className="mt-48">
                            <h6 className="mb-32">
                                Pourquoi Choisir le Khalie de Délices Benkirane ?
                            </h6>
                            <div className="row gy-4">
                                <div className="col-sm-6">
                                    <ul>
                                        <li className="d-flex align-items-start gap-8 mb-20">
                                            <span className="text-xl d-flex flex-shrink-0">
                                                <i className="ph ph-check" />
                                            </span>
                                            <span className="text-gray-700 flex-grow-1">
                                                Recettes authentiques transmises de génération en génération
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-start gap-8 mb-20">
                                            <span className="text-xl d-flex flex-shrink-0">
                                                <i className="ph ph-check" />
                                            </span>
                                            <span className="text-gray-700 flex-grow-1">
                                                Ingrédients de qualité premium sélectionnés avec soin
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-start gap-8 mb-0">
                                            <span className="text-xl d-flex flex-shrink-0">
                                                <i className="ph ph-check" />
                                            </span>
                                            <span className="text-gray-700 flex-grow-1">
                                                Préparation artisanale dans le respect des traditions
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-sm-6">
                                    <ul>
                                        <li className="d-flex align-items-start gap-8 mb-20">
                                            <span className="text-xl d-flex flex-shrink-0">
                                                <i className="ph ph-check" />
                                            </span>
                                            <span className="text-gray-700 flex-grow-1">
                                                Goût intense et saveur unique du terroir fassi
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-start gap-8 mb-20">
                                            <span className="text-xl d-flex flex-shrink-0">
                                                <i className="ph ph-check" />
                                            </span>
                                            <span className="text-gray-700 flex-grow-1">
                                                Polyvalence culinaire pour sublimer tous vos plats
                                            </span>
                                        </li>
                                        <li className="d-flex align-items-start gap-8 mb-0">
                                            <span className="text-xl d-flex flex-shrink-0">
                                                <i className="ph ph-check" />
                                            </span>
                                            <span className="text-gray-700 flex-grow-1">
                                                Garantie fraîcheur et conservation optimale
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="mt-48">
                            <div className="rounded-16 bg-main-50 p-24 blog-quote-wrapper">
                                <span className="w-48 h-48 bg-main-600 text-white flex-center rounded-circle mb-24 text-2xl blog-quote-icon">
                                    <i className="ph ph-quotes" />
                                </span>
                                <p className="text-gray-700 mb-24">
                                    Chez Délices Benkirane, nous croyons que chaque produit raconte une histoire. 
                                    Notre engagement envers l'authenticité et la qualité se reflète dans chaque 
                                    recette traditionnelle que nous préparons avec soin. Nous sommes fiers de 
                                    partager avec vous les saveurs authentiques du Fès, transmises de génération 
                                    en génération.
                                </p>
                                <div className="flex-align gap-8">
                                    <span className="text-15 fw-medium text-neutral-600 d-flex">
                                        <i className="ph-fill ph-star" />
                                    </span>
                                    <span className="text-15 fw-medium text-neutral-600 d-flex">
                                        <i className="ph-fill ph-star" />
                                    </span>
                                    <span className="text-15 fw-medium text-neutral-600 d-flex">
                                        <i className="ph-fill ph-star" />
                                    </span>
                                    <span className="text-15 fw-medium text-neutral-600 d-flex">
                                        <i className="ph-fill ph-star" />
                                    </span>
                                    <span className="text-15 fw-medium text-neutral-600 d-flex">
                                        <i className="ph-fill ph-star" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="mt-48">
                            <div className="flex-align gap-8">
                                <h6 className="mb-0">Mots-clés :</h6>
                                <Link
                                    to="/shop"
                                    className="border border-gray-100 rounded-4 py-6 px-8 hover-bg-gray-100 text-gray-900"
                                >
                                    Khalie
                                </Link>
                                <Link
                                    to="/shop"
                                    className="border border-gray-100 rounded-4 py-6 px-8 hover-bg-gray-100 text-gray-900"
                                >
                                    Recettes
                                </Link>
                                <Link
                                    to="/shop"
                                    className="border border-gray-100 rounded-4 py-6 px-8 hover-bg-gray-100 text-gray-900"
                                >
                                    Tradition
                                </Link>
                            </div>
                        </div>
                        <div className="my-48">
                            <span className="border-bottom border-gray-100 d-block" />
                        </div>
                        <div className="my-48 flex-between flex-sm-nowrap flex-wrap gap-24">
                            <div className="">
                                <button
                                    type="button"
                                    className="mb-20 h6 text-gray-500 text-lg fw-normal hover-text-main-600"
                                >
                                    Article Précédent
                                </button>
                                <h6 className="text-lg mb-0">
                                    <Link to="/blog-details" className="">
                                        Les Secrets de la Préparation du Khalie Traditionnel{" "}
                                    </Link>
                                </h6>
                            </div>
                            <div className="text-end">
                                <button
                                    type="button"
                                    className="mb-20 h6 text-gray-500 text-lg fw-normal hover-text-main-600"
                                >
                                    Suivant
                                </button>
                                <h6 className="text-lg mb-0">
                                    <Link to="/blog-details" className="">
                                        L'Art de la Pâtisserie Fassie : Une Tradition Ancestrale{" "}
                                    </Link>
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 ps-xl-4">
                        {/* Search Start */}
                        <div className="blog-sidebar border border-gray-100 rounded-8 p-32 mb-40">
                            <h6 className="text-xl mb-32 pb-32 border-bottom border-gray-100">
                                Rechercher
                            </h6>
                            <form action="#">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control common-input bg-color-three blog-search-input"
                                        placeholder="Rechercher..."
                                    />
                                    <button
                                        type="submit"
                                        className="btn blog-search-btn text-2xl h-56 w-56 flex-center text-2xl input-group-text"
                                    >
                                        <i className="ph ph-magnifying-glass blog-search-icon" />
                                    </button>
                                </div>
                            </form>
                        </div>
                        {/* Search End */}
                        {/* Articles Start */}
                        <div className="blog-sidebar border border-gray-100 rounded-8 p-32 mb-40">
                            <h6 className="text-xl mb-32 pb-32 border-bottom border-gray-100">
                                Articles Délice du Fès
                            </h6>
                            <ul>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (12)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (05)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (29)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (24)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (08)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-16">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (16)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                                <li className="mb-0">
                                    <Link
                                        to="/blog-details"
                                        className="flex-between gap-8 text-gray-700 border border-gray-100 rounded-4 p-4 ps-16 blog-article-link"
                                    >
                                        <span>Article Délice du Fès (24)</span>
                                        <span className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600 blog-article-icon">
                                            <i className="ph ph-arrow-right" />
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        {/* Articles End */}
                    </div>
                </div>
            </div>
        </section>

    )
}

export default BlogDetails